import CaptureFrontPrompt from 'features/rdc/screens/CaptureFrontPrompt/CaptureFrontPrompt';
import React from 'react';

export default function Page() {
  return <CaptureFrontPrompt />;
}
